import { render, staticRenderFns } from "./AgLanguageText.vue?vue&type=template&id=18aa3be2&"
import script from "./AgLanguageText.vue?vue&type=script&lang=js&"
export * from "./AgLanguageText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports